import { useEffect, useState } from 'react';
import './HeatMapAlcanceUnidades.css';

import Chart from "react-apexcharts";

import { transformaDadosParaGraficoHeatMap, preencherDadosFaltantesParaGraficos } from '../../../util/utilitarios';
import { servGetGraficoPercentualAlcanceEstabelecimentosHeatMap } from '../../../servicos/graficos_indicador';

function HeatMapAlcanceUnidades({ dataInicio, dataFim }) {

    const [dadosHeatMap, setDadosHeatMap] = useState(null)

    const options = {
        dataLabels: { enabled: true, style: { colors: ['#ffffff'] } },
        plotOptions: {
            legend: { show: true },
            noData: { text: 'Não há dados para os filtros selecionados' },
            heatmap: {
                shadeIntensity: 0.0,
                radius: 0,
                useFillColorAsStroke: false,
                colorScale: {
                    ranges: [
                        { // vermelho
                            from: 0,
                            to: 49.9,
                            name: '< 50%',
                            color: '#FF0000'
                        },
                        { // laranja
                            from: 50,
                            to: 59.9,
                            name: '50% - 59%',
                            color: '#FFB200'
                        },
                        { // amarelo
                            from: 60,
                            to: 69.9,
                            name: '60% - 69%',
                            color: '#e6e600'
                        },
                        { // verde mais claro
                            from: 70,
                            to: 79.9,
                            name: '70% - 79%',
                            color: '#00cc00'
                        },
                        { // verde
                            from: 80,
                            to: 89.9,
                            name: '80% - 89%',
                            color: '#00A100'
                        },
                        { // azul
                            from: 90,
                            to: 100,
                            name: '90% - 100%',
                            color: '#128FD9'
                        }
                    ]
                }
            }
        }
    }

    useEffect(() => {
        getGraficoPercentualAlcanceEstabelecimentosHeatMap()
    }, [dataInicio, dataFim]);

    const getGraficoPercentualAlcanceEstabelecimentosHeatMap = async () => {
        try {
            const dadosHeatMapDaApi = await servGetGraficoPercentualAlcanceEstabelecimentosHeatMap(dataInicio, dataFim)
            setDadosHeatMap(transformaDadosParaGraficoHeatMap(dadosHeatMapDaApi.data))
        } catch (erro) {
            console.error(erro);
        }
    }

    return (
        <div className='h-100 div-com-borda'>
            {dadosHeatMap &&
                <Chart
                    options={options}
                    series={preencherDadosFaltantesParaGraficos(dadosHeatMap)}
                    type="heatmap"
                    height="100%"
                />}
        </div>
    );

}

export default HeatMapAlcanceUnidades
